import styled from 'styled-components';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 20px #00000029;
  height: 120px;
  margin-bottom: 60px;
  cursor: pointer;
`;

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

type CardImgContaineProps = {
  imgURL?: string;
};

export const CardImgContainer = styled.div<CardImgContaineProps>`
  display: flex;
  flex: 1;
  border-radius: 4px 4px 0 0;
  max-height: 50%;
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: transparent linear-gradient(180deg, #ffffff 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 4px 4px;
  box-shadow: 0px 5px 5px #00000029;
`;

export const CardContentTitle = styled.p`
  font-size: 14px;
  color: #1c1b3a;
  font-weight: 600;
  margin: 10px 0 0 10px;
`;

export const CardContentSubtitle = styled.p`
  font-size: 12px;
  min-height: 12px;
  color: #1c1b3a;
  font-weight: normal;
  margin: 10px 0 0 10px;
`;

export const CardUserActionTag = styled.p`
  font-size: 12px;
  font-weight: 600;
  margin: 0 10px 0 0;
  color: #ff0000;
  text-transform: uppercase;
`;

export const CardAdminActionTag = styled.p`
  font-size: 12px;
  font-weight: 600;
  margin: 0 10px 0 0;
  color: #ff0000;
  text-transform: uppercase;
  padding: 3px;
  border-radius: 5px;
`;

export const CardFooterTag = styled.div`
  display: flex;
  margin: 10px 0 5px 10px;
  justify-content: space-between;
`;

export const CardActionButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

type ButtonProps = {
  isActive: boolean;
};

export const ApproveButton = styled.button<ButtonProps>`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid ${props => (props.isActive ? '#28a745' : '#6c757d')};
  background-color: ${props => (props.isActive ? '#28a745' : 'transparent')};
  color: ${props => (props.isActive ? '#ffffff' : '#28a745')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => (props.isActive ? '#218838' : '#28a745')};
    color: #ffffff;
    border-color: ${props => (props.isActive ? '#218838' : '#28a745')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DeclineButton = styled.button<ButtonProps>`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid ${props => (props.isActive ? '#dc3545' : '#6c757d')};
  background-color: ${props => (props.isActive ? '#dc3545' : 'transparent')};
  color: ${props => (props.isActive ? '#ffffff' : '#dc3545')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => (props.isActive ? '#c82333' : '#dc3545')};
    color: #ffffff;
    border-color: ${props => (props.isActive ? '#c82333' : '#dc3545')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
